/**
 * The bills' and payments' filters, kept in the address (doc 57), as arqam's
 * filters. The figures (status, remaining) are arqam's; only chosen here.
 */

export const BILL_FILTER_KEYS = [
  'from',
  'to',
  'q',
  'status',
  'member',
  'meter',
  'photo',
] as const;

export const PAYMENT_FILTER_KEYS = ['from', 'to', 'q', 'by', 'member'] as const;

const dateRange = (from: string | null, to: string | null) =>
  from || to
    ? {
        ...(from ? { greaterThanOrEqualTo: from } : {}),
        ...(to ? { lessThanOrEqualTo: to } : {}),
      }
    : null;

export function billsFilter(params: URLSearchParams) {
  const and: Record<string, unknown>[] = [];
  const month = dateRange(params.get('from'), params.get('to'));
  if (month) and.push({ billMonth: month });
  const status = params.get('status');
  if (status === 'unpaid') {
    and.push({ billStatus: { in: ['PENDING', 'OVERDUE'] } });
  } else if (
    status === 'PAID' ||
    status === 'PENDING' ||
    status === 'OVERDUE'
  ) {
    and.push({ billStatus: { equalTo: status } });
  }
  const member = params.get('member');
  if (member) and.push({ memberId: { equalTo: member } });
  const meter = params.get('meter');
  if (meter) and.push({ meterId: { equalTo: meter } });
  const photo = params.get('photo');
  if (photo === 'with') and.push({ readingPhotoExists: true });
  if (photo === 'without') and.push({ readingPhotoExists: false });
  const q = params.get('q')?.trim();
  if (q) {
    and.push({
      or: [
        { member: { fullName: { includesInsensitive: q } } },
        { meter: { label: { includesInsensitive: q } } },
      ],
    });
  }
  return and.length ? { and } : null;
}

/** The day after "YYYY-MM-DD". */
const nextDay = (date: string) => {
  const d = new Date(`${date}T00:00:00Z`);
  d.setUTCDate(d.getUTCDate() + 1);
  return d.toISOString().slice(0, 10);
};

export function paymentsFilter(params: URLSearchParams) {
  const and: Record<string, unknown>[] = [];
  // `paymentDate` is a time: up to the end of the last day.
  const from = params.get('from');
  const to = params.get('to');
  if (from || to) {
    and.push({
      paymentDate: {
        ...(from ? { greaterThanOrEqualTo: from } : {}),
        ...(to ? { lessThan: nextDay(to) } : {}),
      },
    });
  }
  const by = params.get('by');
  if (by) and.push({ receivedBy: { equalTo: by } });
  const member = params.get('member');
  if (member) and.push({ bill: { memberId: { equalTo: member } } });
  const q = params.get('q')?.trim();
  if (q) {
    and.push({
      or: [
        { receiptNo: { includesInsensitive: q } },
        { bill: { member: { fullName: { includesInsensitive: q } } } },
      ],
    });
  }
  return and.length ? { and } : null;
}
